import { defaultToastConfig } from '@/common/config/toast';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';

const ToastNotification = (
  text: string,
  picture?: { img: string; webp?: string },
  className?: string,
): void => {
  showToast(text, picture, {
    ...defaultToastConfig,
    className,
  });
};

export { ToastNotification };
